function o(a) {
  const t = "[ \\t\\f]*", r = "[ \\t\\f]+", n = t + "[:=]" + t, s = r, i = "(" + n + "|" + s + ")", e = "([^\\\\:= \\t\\f\\n]|\\\\.)+", c = {
    // skip DELIM
    end: i,
    relevance: 0,
    starts: {
      // value: everything until end of line (again, taking into account backslashes)
      className: "string",
      end: /$/,
      relevance: 0,
      contains: [
        { begin: "\\\\\\\\" },
        { begin: "\\\\\\n" }
      ]
    }
  };
  return {
    name: ".properties",
    disableAutodetect: !0,
    case_insensitive: !0,
    illegal: /\S/,
    contains: [
      a.COMMENT("^\\s*[!#]", "$"),
      // key: everything until whitespace or = or : (taking into account backslashes)
      // case of a key-value pair
      {
        returnBegin: !0,
        variants: [
          { begin: e + n },
          { begin: e + s }
        ],
        contains: [
          {
            className: "attr",
            begin: e,
            endsParent: !0
          }
        ],
        starts: c
      },
      // case of an empty key
      {
        className: "attr",
        begin: e + t + "$"
      }
    ]
  };
}
export {
  o as default
};
